<div id="step2_setUpParameters" class="collapse" style="clear: both; display: none;">
		
	<!-- Title -->
	<h1 style="color:#f57300; font-size: 50px">
		<i class="fa fa-cog" aria-hidden="true"></i>
		STEP 2: SET UP PARAMETERS
	</h1>
	
	<!-- Instructions -->
	<p style="color: #ffffff; font-size: 18px">
		Select the parameters that will go along with the selected triggger.
	</p>
	
	<!-- Main Body -->
	<div class="col-sum-9">
		<!-- Display a warning if no Trigger is selected since no Parameters can be specified without it -->
		<ng-container *ngIf="mRule.event == null">
			<h3>
				<i>Parameters cannot be shown until a trigger is selected.</i>
			</h3>
		</ng-container>
		
		<!-- Handle the case if the Trigger is selected... Allow the User to specify the parameters -->
		<ng-container *ngIf="mRule.event != null">
		
			<!-- Event Trigger IS Dialog Response... Different handling then the rest for some reason -->
			<ng-container *ngIf="mRule.event.name == 'Dialog Response'">
				<app-dialog-parameter-editor
					[rule]="this.mRule"
					>
				</app-dialog-parameter-editor>
			</ng-container>
			
			<!-- Event Trigger is NOT Dialog Response -->
			<ng-container *ngIf="mRule.event.name != 'Dialog Response'">
			
			<!-- ADD PARAMETER Button -->
				<div class="dropdown">
					<button class="btn btn-default btn-lg dropdown-toggle" type="button" data-toggle="dropdown">
						<i class="fa fa-circle" aria-hidden="true"></i>
						ADD PARAMETER
						<span class="caret"></span>
					</button>
					<ul class="dropdown-menu" style="max-height: 200px; overflow-y: auto">
						<ng-container *ngIf="mRule.event.properties != null">
							<li (click)="addParameterForProperty(property)" *ngFor="let property of mRule.event.properties">
								<a data-toggle="collapse">
									<i class="fa {{getGlpyhForPropertyType(property)}}" aria-hidden="true"></i>
									{{property.name}}
								</a>
							</li>
						</ng-container>
						<li>
							<a data-toggle="collapse">
								<i class="fa fa-bolt" aria-hidden="true"></i>
								Deactivation Delay / Trigger
							</a>
						</li>
						<li>
							<a data-toggle="collapse">
								<i class="fa fa-bolt" aria-hidden="true"></i>
								Activation Delay / Trigger
							</a>
						</li>
					</ul>
				</div>
			</ng-container>
		</ng-container>
	</div>
	
	<ng-container *ngIf="mRule.conditions != null && mRule.event != null && mRule.event.name != 'Dialog Response'">
		<div style="margin-top: 10px;"></div>
		<div class="col-sm-9">
			<ng-container *ngFor="let condition of mRule.conditions">
				<div *ngIf="condition.sourceType == mSourceTypes.EVENT" class="panel panel-drk-ornge">
					<ng-container [ngSwitch]="true">
						<app-entity-parameter-editor *ngSwitchCase="condition.propertyType == 'LOCATION_REFERENCE' ||
																	condition.propertyType == 'TAG_REFERENCE' || 
																	condition.propertyType == 'OBJECT_REFERENCE' || 
																	condition.propertyType == 'ZONE_REFERENCE' ||
																	condition.propertyType == 'READER_REFERENCE'"
							[rule]="this.mRule"
							[ruleCondition]="condition" >
						</app-entity-parameter-editor>

						<app-day-parameter-editor *ngSwitchCase="condition.propertyType == 'DAY'"
							[rule]="this.mRule"
							[ruleCondition]="condition" >
						</app-day-parameter-editor>

						<app-time-parameter-editor *ngSwitchCase="condition.propertyType == 'TIME'"
							[rule]="this.mRule"
							[ruleCondition]="condition" >
						</app-time-parameter-editor>
						
						<div *ngSwitchDefault>
							
							<app-rule-parameter-editor 
								[rule]="this.mRule"
								[ruleCondition]="condition" >
							</app-rule-parameter-editor>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>